const state = {
    activationDataFields: [
        {
            key: "date",
            label: "日期",
            sortable: true,
            class: "font-family-dfyuanstd-w5"
        },
        {
            key: "activation",
            label: "稼動率",
            sortable: true,
            class: "font-family-dfyuanstd-w5"
        }
    ],
    activationDataItem: []
}
const getters = {
    get_activationDataFields: state => {
        return state.activationDataFields
    },
    get_activationDataItem: state => {
        return state.activationDataItem
    }
}
const actions = {
    set_activationDataFields(context, array) {
        context.commit('SET_ACTIVATIONDATAFIELDS', array);
    },
    set_activationDataItem(context, array) {
        context.commit('SET_ACTIVATIONDATAITEM', array);
    },
    clear_activationDataItem(context) {
        context.commit('CLEAR_ACTIVATIONDATAITEM');
    }
}
const mutations = {
    SET_ACTIVATIONDATAFIELDS(state, array) {
        state.activationDataFields = array;
    },
    SET_ACTIVATIONDATAITEM(state, array) {
        state.activationDataItem = array;
    },
    CLEAR_ACTIVATIONDATAITEM(state) {
        state.activationDataItem = [];
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/activationData.js